import { makeAutoObservable, runInAction } from "mobx";
import { IRmaActionSubmitStore } from "../rma-types";

class RmaActionStore implements IRmaActionSubmitStore {
    private _isProcessing: boolean = false;

    constructor(private _actionCallback: () => void) {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get isProcessing(): boolean {
        return this._isProcessing;
    }

    public async submitAction(closeCb?: () => void) {
        try {
            this._isProcessing = true;
            await this._actionCallback();
            runInAction(() => {
                this._isProcessing = false;
                if (closeCb) {
                    closeCb();
                }
            });
        } catch (e) {
            runInAction(() => {
                this._isProcessing = false;
            });
        }
    }
}

export default RmaActionStore;
